import React from 'react';
import { Skeleton } from '../../ui/skeleton';
import { Card, CardContent, CardHeader } from '../../ui/card';

const FormLoadingSkeleton = ({ 
  fields = 4,
  showTitle = true,
  sections = 1,
  showButtons = true,
  className = ""
}) => {
  return (
    <div className={`space-y-6 ${className}`}>
      {showTitle && (
        <div className="space-y-2">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-96" />
        </div>
      )}
      
      {[...Array(sections)].map((_, sectionIndex) => (
        <Card key={sectionIndex} className="bg-slate-50 border-slate-200">
          <CardHeader>
            <Skeleton className="h-5 w-40" />
          </CardHeader>
          <CardContent className="space-y-4">
            {[...Array(fields)].map((_, fieldIndex) => (
              <div key={fieldIndex} className="space-y-2">
                {/* Label */}
                <Skeleton className="h-4 w-24" />
                {/* Input Field */}
                <Skeleton className="h-10 w-full" />
                {/* Helper text */}
                {fieldIndex % 2 === 0 && (
                  <Skeleton className="h-3 w-48" />
                )}
              </div>
            ))}
            
            {/* Toggle/Switch fields */}
            {sectionIndex === 0 && (
              <div className="flex items-center justify-between pt-4">
                <div className="space-y-1">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-3 w-48" />
                </div>
                <Skeleton className="h-6 w-11 rounded-full" />
              </div>
            )}
          </CardContent>
        </Card>
      ))}
      
      {showButtons && (
        <div className="flex justify-end gap-2">
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-32" />
        </div>
      )}
    </div>
  );
};

export default FormLoadingSkeleton;